import React, { useEffect, useState } from "react"
import { AssetMap, HoleSponsor } from "../types"
import Avatar from "../Avatar"

interface HelpModalProps {
  sponsor: HoleSponsor
  assets: AssetMap
  dismiss()
}

export default function SponsorModal({ sponsor, assets, dismiss }: HelpModalProps) {
  const [height, setHeight] = useState(window.innerHeight)
  const updateDimensions = () => setHeight(window.innerHeight)
  useEffect(() => {
    window.addEventListener("resize", updateDimensions)
    return () => window.removeEventListener("resize", updateDimensions)
  }, [])

  return (
    <div id="round-sponsor-modal" className="modal modal--bottom-sheet-mobile show">
      <div className="modal-wrapper">
        <div className="modal-header">
          <div className="modal-header-inner">
            <div className="modal-title">Hole Sponsor</div>
            <a onClick={dismiss} className="modal-dismiss">
              <img src={assets.close} alt="Close" />
            </a>
          </div>
        </div>
        <div className="modal-main">
          <div className="container" style={{ maxHeight: height - 200, overflowY: "auto" }}>
            {sponsor.photoUrl ? (
              <img src={sponsor.photoUrl} alt={sponsor.name} style={{ borderRadius: "0.5rem 0.5rem 0 0" }} />
            ) : (
              <div>&nbsp;</div>
            )}
            <h2 style={{ marginTop: "1rem" }}>{sponsor.name}</h2>
            {sponsor.subtitle ? <div>{sponsor.subtitle}</div> : <></>}
            {sponsor.descriptionHtml ? (
              <div
                className="simple-format"
                dangerouslySetInnerHTML={{ __html: sponsor.descriptionHtml }}
                style={{ marginTop: "1rem" }}
              ></div>
            ) : (
              <></>
            )}
            {sponsor.postedBy ? (
              <div
                style={{
                  border: "1px solid #CCC",
                  borderRadius: "0.5rem",
                  marginTop: "1rem",
                  padding: "1rem",
                  display: "flex"
                }}
              >
                <>
                  <Avatar user={sponsor.postedBy} />
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "1rem" }}>
                    <div style={{ fontSize: "0.75rem" }}>Posted by</div>
                    <div style={{ fontWeight: 700 }}>{sponsor.postedBy.name}</div>
                  </div>
                </>
              </div>
            ) : (
              <></>
            )}
            {sponsor.linkUrl ? (
              <div style={{ width: "100%", marginTop: "1rem", textAlign: "center" }}>
                <a className="action-button" href={sponsor.linkUrl} target="_blank">
                  Visit Website
                </a>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <div className="modal-mask" onClick={dismiss} />
    </div>
  )
}
